// extracted by mini-css-extract-plugin
export var circle = "_k-2";
export var icon = "_k-a";
export var iconHighlight = "_k-0";
export var lg = "_k-8";
export var md = "_k-7";
export var outline = "_k-4";
export var sm = "_k-6";
export var square = "_k-1";
export var xl = "_k-9";
export var xs = "_k-5";
export var xxs = "_k-3";